import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';

import { RedirectionStateFactory, RedirectionStateReducer } from './store';



@NgModule({
  imports: [
    StoreModule.forFeature('redirectionResource', RedirectionStateReducer.reduce, {
      initialState: RedirectionStateFactory.getInitialState
    })
  ]
})
export class RedirectionResourceModule {}
